module.exports = __webpack_public_path__ + "static/media/online-doctor-consultation-digital-healthcare-app-1200.eb381110.webp";